import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

interface ProtectedRouteProps {
  allowedRoles?: string[];
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  allowedRoles = [],
}) => {
  const { currentUser, isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Users still going through onboarding can only access the My Onboarding
  // portal — bounce every other protected route back there.
  if (
    currentUser?.status === "Onboarding" &&
    !location.pathname.startsWith("/my-onboarding")
  ) {
    return <Navigate to="/my-onboarding" replace />;
  }

  if (
    allowedRoles.length === 0 ||
    (currentUser && allowedRoles.includes(currentUser.userRole))
  ) {
    return <Outlet />;
  }

  return <Navigate to="/dashboard" replace />;
};
